import { render, staticRenderFns } from "./LaBoutiqueSoBookHome.vue?vue&type=template&id=cfc1a58c&scoped=true&"
import script from "./LaBoutiqueSoBookHome.vue?vue&type=script&lang=js&"
export * from "./LaBoutiqueSoBookHome.vue?vue&type=script&lang=js&"
import style0 from "./LaBoutiqueSoBookHome.vue?vue&type=style&index=0&id=cfc1a58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc1a58c",
  null
  
)

export default component.exports